import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectMedicalExpenseStep = (state) => state.get('medicalExpenseStep');

const makeSelectMedicalExpenseStep = () => createSelector(
  selectMedicalExpenseStep,
  (stepMedicalExpenseState) => ({
    doYouHaveAnyOtherTypeOfCoverage: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'doYouHaveAnyOtherTypeOfCoverage']),
      ''
    ),
    insuranceCarriersName: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'insuranceCarriersName']),
      ''
    ),
    natureOfInjury: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'natureOfInjury']),
      ''
    ),
    address: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'cityOrTown']),
      ''
    ),
    country: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'country']),
      ''
    ),
    postalCode: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'postalCode']),
      ''
    ),
    policyId: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'policyId']),
      ''
    ),

    dateTravelArrangementsWereMade: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'dateTravelArrangementsWereMade']),
      ''
    ),
    dateOfInitialPaymentDeposit: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'dateOfInitialPaymentDeposit']),
      ''
    ),
    typeOfPolicy: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'typeOfPolicy']),
      ''
    ),
    contact: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'contact']),
      ''
    ),
    phoneNumber: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'phoneNumber']),
      ''
    ),
    haveYouFiledAClaimWithTheirOfficeAtThisTime: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'haveYouFiledAClaimWithTheirOfficeAtThisTime']),
      ''
    ),
    nameOfPersonHavingSicknessOrInjury: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'nameOfPersonHavingSicknessOrInjury']),
      ''
    ),
    hisOrHerDateOfBirth: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'hisOrHerDateOfBirth']),
      ''
    ),
    isTheClaimTheResultOfASicknessOrInjury: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'isTheClaimTheResultOfASicknessOrInjury']),
      ''
    ),
    natureOfSickness: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'natureOfSickness']),
      ''
    ),
    accidentOfInjury: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'accidentOfInjury']),
      ''
    ),
    dateNature: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'dateNature']),
      ''
    ),
    placeNature: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'placeNature']),
      ''
    ),
    fromDateNature: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'fromDateNature']),
      ''
    ),
    toDateNature: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'toDateNature']),
      ''
    ),
    endDateNature: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'endDateNature']),
      ''
    ),
    wasThereAnAccidentReportForThisIncident: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'wasThereAnAccidentReportForThisIncident']),
      ''
    ),
    pleaseNoteTheirResponse: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'pleaseNoteTheirResponse']),
      ''
    ),
    whyNot: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'whyNot']),
      ''
    ),
    wasThereAnyPreviousTreatmentForThisCondition: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'wasThereAnyPreviousTreatmentForThisCondition']),
      ''
    ),
    dateSicknessOrInjuryBegan: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'dateSicknessOrInjuryBegan']),
      ''
    ),
    dateFirstTreated: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'dateFirstTreated']),
      ''
    ),
    nameOfPhysician: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'nameOfPhysician']),
      ''
    ),
    datesOfTreatment: mapWithDefault(
      stepMedicalExpenseState,
      () => stepMedicalExpenseState.getIn(['form', 'datesOfTreatment']),
      ''
    ),
    expenseDescriptionOfItems: mapWithDefault(stepMedicalExpenseState, () => stepMedicalExpenseState.getIn(['form', 'expenseDescriptionOfItems']) && stepMedicalExpenseState.getIn(['form', 'expenseDescriptionOfItems']).toJS(), ''),
    treatmentDates: mapWithDefault(stepMedicalExpenseState, () => stepMedicalExpenseState.getIn(['form', 'treatmentDates']) && stepMedicalExpenseState.getIn(['form', 'treatmentDates']).toJS(), []),
  })
);

const makeSelectMedicalExpenseStepErrors = () =>
  createSelector(selectMedicalExpenseStep, (state) => state.get('errors'));

export {
  makeSelectMedicalExpenseStep,
  makeSelectMedicalExpenseStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.MedicalExpenseStep/selectors.js